import { Component, OnInit } from '@angular/core';
import {Message} from "primeng/primeng";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Inventario} from "./inventario";
import {InventarioService} from "../Services/inventario.service";
import {TiendaService} from "../Services/tienda.service";
import {Tienda} from "../tienda/tienda";



@Component({
  selector: 'app-inventario',
  templateUrl: './inventario.component.html',
  styleUrls: ['./inventario.component.css']
})
export class InventarioComponent implements OnInit {
  msgs: Message[] = [];

  btnNuevo = true;
  btnCancelar = false;
  btnGuardar = false;
  btnGuardarEditar = false;
  panelRequeridos = false;
  loading = false;
  InventariosRegistrados:Inventario[];
  InventarioSeleccionado:Inventario;
  tipoGuardado = '';
  TiendasRegistrados:Tienda[];
  verEdicionCantidad = false;
  tiendaSeleccionada = 0;
  role = localStorage.getItem('role');

  constructor(private servicioInventario:InventarioService,private servicioTienda:TiendaService) { }

  ngOnInit() {
    this.listarTiendas();
  }
  mensajes(severity,summary,detail){
    this.msgs = [];
    this.msgs.push({severity:severity, summary:summary, detail:detail});
  }
  EvniarEdicion(item:Inventario){
    if(this.role == 'Administrador' || this.role == 'Propietario'){
      this.InventarioSeleccionado = item;
      this.loading = true;
      this.servicioInventario.putInventario(item,this.InventarioSeleccionado.idInventario)
        .subscribe(
          rt => {
            this.mensajes('success','Actualizacion',rt);
            this.ListarInventarioTienda(this.tiendaSeleccionada);
            this.loading = false;
          },
          er => {
            this.mensajes('error','Error',er);
            this.loading = false;
          },
          () =>  {
            this.verEdicionCantidad = false;
          });
    }else {
      this.mensajes('warn','Atencion','Para la gestion de Tiendas contacte con Administrador.');
    }

  }
  listarTiendas(){
    this.loading = true;
    this.servicioTienda.getTienda()
      .subscribe(
        rt => {
          this.TiendasRegistrados = rt;
          this.loading = false;
        },
        er => this.mensajes('error','Error',er),
        () =>  {
        }
      );
  }
  ListarInventarioTienda(item){
    if(item != 0){
      this.tiendaSeleccionada = item;
      this.loading = true;
      this.servicioInventario.getInventarioByTienda(item)
        .subscribe(
          rt => {
            this.InventariosRegistrados = rt;
            console.log(rt);
            this.loading = false;
          },
          er => this.mensajes('error','Error',er),
          () =>  {
          }
        );
    }
  }
}



// WEBPACK FOOTER //
// H:/Proyectos Galeras Indie/Vinta/vinta Tinka/VintaWebClient/src/app/inventario/inventario.component.ts